class UserModel {
  public CrossCheck: number;
  public Jwt: string;
  public Username: string;
  public ADRoles?: string[];
  constructor(public UserId: number) {
  }
}

export { UserModel };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/login/_domain/models/user-model.ts